<app-dialog-container [showKeyboardButton]="false" [showHelpButton]="false">
  <h1 mat-dialog-title>{{ title }}</h1>
  <div mat-dialog-content class="responsible-dialog" [formGroup]="form">
    <div class="responsible-grid responsible-grid-2">
      <mat-form-field appearance="outline">
        <mat-label>FILIAL</mat-label>
        <mat-select formControlName="enterpriseKey">
          <mat-option value="">Sem filial</mat-option>
          <mat-option *ngFor="let branch of branches" [value]="branch.localKey">
            {{ branch.branchTitle }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <app-input [config]="config('responsibleName')" [group]="form" [typeCes]="fieldType"></app-input>
    </div>
    <div class="responsible-grid responsible-grid-3">
      <app-input [config]="config('responsibleCpf')" [group]="form" [typeCes]="fieldType"></app-input>
      <app-input [config]="config('responsibleRg')" [group]="form" [typeCes]="fieldType"></app-input>
      <app-input [config]="config('responsibleNationality')" [group]="form" [typeCes]="fieldType"></app-input>
    </div>
    <div class="responsible-grid responsible-grid-3">
      <app-input [config]="config('responsiblePhone')" [group]="form" [typeCes]="fieldType"></app-input>
      <app-input [config]="config('responsibleEmail')" [group]="form" [typeCes]="fieldType"></app-input>
      <app-input [config]="config('responsibleBirthDate')" [group]="form" [typeCes]="fieldType"></app-input>
    </div>
    <div class="responsible-grid responsible-grid-4">
      <app-input [config]="config('responsibleZipCode')" [group]="form" [typeCes]="fieldType" (onChange)="lookupCep()"></app-input>
      <app-input [config]="config('responsibleAddress')" [group]="form" [typeCes]="fieldType"></app-input>
      <app-input [config]="config('responsibleNumber')" [group]="form" [typeCes]="fieldType"></app-input>
      <app-input [config]="config('responsibleNeighborhood')" [group]="form" [typeCes]="fieldType"></app-input>
    </div>
    <div class="responsible-grid responsible-grid-3">
      <app-input [config]="config('responsibleCity')" [group]="form" [typeCes]="fieldType"></app-input>
      <app-input [config]="config('responsibleState')" [group]="form" [typeCes]="fieldType"></app-input>
      <app-input [config]="config('responsibleComplement')" [group]="form" [typeCes]="fieldType"></app-input>
    </div>
  </div>
  <app-dialog-save-close
    *ngIf="!viewMode"
    [closeOnSave]="false"
    closeText="VOLTAR"
    (onSave)="save()">
  </app-dialog-save-close>
  <div *ngIf="viewMode" mat-dialog-actions align="end">
    <button type="button" class="custom-button" mat-raised-button (click)="close()">VOLTAR</button>
  </div>
</app-dialog-container>
